import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import ModuleList from '../../../layout/ModuleList';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import { clearBaggageItems, getItems } from '../../../../actions';
import { ITEM_PATH } from '../../../../config/paths';
import { COLLECTION_SHAPE } from '../../../../config/shapes';
import { ITEMS_COLUMNS } from '../../../../config/columns';

const Items = ({
  breadcrumbs,
  dispatchGetItems,
  loading,
  items,
  dispatchClearItems,
}) => {
  useLayoutEffect(() => () => dispatchClearItems(), []);

  const data = items.get('content') || [];
  const pages = items.get('totalPages') || null;
  const defaultPageSize = items.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Listado de Equipajes"
      breadcrumbs={breadcrumbs}
      tableStructure={{
        columns: ITEMS_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetItems,
        modelPath: ITEM_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

Items.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchGetItems: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  items: PropTypes.instanceOf(Immutable.Map),
  dispatchClearItems: PropTypes.func.isRequired,
};

Items.defaultProps = {
  loading: false,
  items: Immutable.Map(COLLECTION_SHAPE),
};

const mapStateToProps = ({ BaggageUnit }) => ({
  breadcrumbs: [
    ...BaggageUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Listado de Equipajes',
      href: '',
    },
  ],
  loading: BaggageUnit.Item.getIn(['content', 'loading']),
  items: BaggageUnit.Item.getIn(['content', 'content']),
});

const mapDispatchToProps = {
  dispatchGetItems: getItems,
  dispatchClearItems: clearBaggageItems,
};

export default connect(mapStateToProps, mapDispatchToProps)(Items);
